/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PermissionDto } from '../../models/permission-dto';

export interface GetPermissions$Params {
  id: string;
}

export function getPermissions(http: HttpClient, rootUrl: string, params: GetPermissions$Params, context?: HttpContext): Observable<StrictHttpResponse<PermissionDto>> {
  const rb = new RequestBuilder(rootUrl, getPermissions.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PermissionDto>;
    })
  );
}

getPermissions.PATH = '/management-companies/{id}/permissions';
